<template>
  <div>
    <!-- 导航组件封装 -->
    <Navigation></Navigation>
    <div class="container-xl top">
      <!-- <img src="../img/Frame69492x.png" alt="" /> -->
      <div class="computer">
        <img src="../img/Frame 7116.png" alt="" />
      </div>
      <div class="move">
        <img src="https://beame.oss-cn-hongkong.aliyuncs.com/mobilePicture/Group14990.png" alt="" />
      </div>
    </div>
    <div class="container-xl shop">
      <h2>请选择您的位置进行预约</h2>
      <div class="place">
        <van-collapse
          v-model="activeNames"
          v-for="(value, index) in records"
          :key="index"
        >
          <van-collapse-item :name="index">
            <template #title>
              <div class="name" v-if="index === 0">
                <van-loading type="spinner" color="#00e467" />
              </div>
              <div v-else class="name">{{ index }}</div>
            </template>

            <div class="deta" v-for="val in value">
              <h3>{{ val.name }}</h3>
              <img :src="val.img" alt="" />
              <p>
                <img src="../img/icons@2x1.png" alt="" />&nbsp;{{ val.phone }}
              </p>
              <p>
                <img src="../img/button icon@2x1.png" alt="" />&nbsp;{{
                  val.BH || GetHb(val)
                }}
              </p>
              <p>
                <img src="../img/button icon_1@2x1.png" alt="" />&nbsp;{{
                  val.address
                }}
              </p>
              <button
                style="background: #323e48 100%; color: #00e467"
                @click="kap1(val)"
              >
                免费预约口扫</button
              ><br />
              <button @click="kap2(val)">预约免费牙齿美白</button>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>

    <div class="container-xl shine">
      <div class="row">
        <div class="col-lg-6 Blooming">
          <h2>
            助你绽放 <br />
            独特光芒
          </h2>
          <p>
            我们拥有本地专业牙科团队和顶<br />
            级医疗设备，使医疗创新和个人<br />成长不再遥远。
          </p>
          <router-link to="/advantage"><h4>了解更多</h4></router-link>
        </div>
        <div class="col-lg-6 form">
          <img src="../img/Group73.png" alt="" />
        </div>
      </div>
    </div>
    <div class="container-xl">
      <div class="row advantage">
        <h2>我们的优势</h2>
        <div class="col-lg-4 team">
          <img src="../img/Frame 67906.png" alt="" />
          <h4>香港专业医疗团队</h4>
          <p>
            我们拥有来自香港的专业医疗团队和优质的港式医疗设备。携手香港大学牙科医生林教授，矫正全程一对一指导，效果保障。
          </p>
        </div>
        <div class="col-lg-4 team">
          <img src="../img/Frame 67961.png" alt="" />

          <h4>高科技智能3D取模</h4>
          <p>
            5 分钟快速检查，<br />
            全方位获取口腔数据
          </p>
        </div>
        <div class="col-lg-4 team">
          <img src="../img/Frame 67951.png" alt="" />
          <h4>AI 数字化矫正方案</h4>
          <p>
            根据检查结果模拟数据诊断分析，<br />
            为你定制精准高效的矫齿方案。
          </p>
        </div>
      </div>
    </div>
    <div class="container-xl live">
      <h2>活出你的光芒</h2>
      <div class="row Yours">
        <div class="col-lg-3 lasting">
          <img src="../img/Frame 6796@2x.png" alt="" />
          <h4>舒适柔韧</h4>
          <p>
            创新材质具有超强弹性，<br />为牙齿移动提供轻柔持续的力度，佩戴舒适且不易变形。
          </p>
        </div>
        <div class="col-lg-3 lasting">
          <img src="../img/Frame 6796_1@2x.png" alt="" />
          <h4>持久应力</h4>
          <p>
            持续提供精准的矫正力度，<br />
            让矫正更符合治疗周期。
          </p>
        </div>
        <div class="col-lg-3 lasting">
          <img src="../img/Frame 6796_2@2x.png" alt="" />
          <h4>抗撕裂性强</h4>
          <p>
            综合抗撕裂性较普通矫治资料提升30% <br />
            ，大幅减少断裂可能，摘带安心。
          </p>
        </div>
        <div class="col-lg-3 lasting">
          <img src="../img/Frame 6795@2x.png" alt="" />
          <h4>不易染色</h4>
          <p>德国进口的创新材质，抗染色效能<br />提升30%，佩戴过程不易变色</p>
        </div>
      </div>
    </div>
    <!-- 底部组件封装 -->
    <Bottom></Bottom>
  </div>
</template>
<script>
import { getAllOutpatientCityInfozh } from "@/api/outpatient";

import Navigation from "@/components/Navigation.vue";
import Bottom from "@/components/Bottom.vue";

export default {
  metaInfo: {
    link: [
      {
        rel: "canonical",
        href: "https://mybeame.com/about",
      },
      {
        rel: "alternate",
        href: "https://mybeame.com/about",
        hrefLang: "x-default",
      },
    ],
  },
  components: {
    Navigation,
    Bottom,
  },
  data() {
    return {
      city: "",
      maila: "",
      textarea: "",
      activeNames: ["香港", "澳门", "深圳"], //门诊折叠面板
      records: {},
    };
  },
  mounted() {
    this.loadData();
    localStorage.removeItem("city"); //清除本地储存
    localStorage.removeItem("time");
    localStorage.removeItem("comeFrom");
    localStorage.removeItem("liaison");
  },
  methods: {
    //获取后台门诊信息
    loadData() {
      var params = "";
      if (this.select) {
        params += "&&city=" + this.select;
      }
      getAllOutpatientCityInfozh(params)
        .then((res) => {
          this.records = res.data;
        })
        .catch((err) => {});
    },

    //确定预约事件
    kap1(city) {
      localStorage.setItem("city", JSON.stringify(city));
      this.$router.push("/clinic");
    },
    kap2(city) {
      //这个是牙齿美白
      localStorage.setItem("comeFrom", String(7));
      localStorage.setItem("city", JSON.stringify(city));
      this.$router.push("/clinicmb");
    },

    //转换时间
    GetHb: function (e) {
      var time = e.appointmentStart;
      var bh = "";
      if (time % 2 == 0) {
        bh = parseInt(time / 2) + ":00";
      } else {
        bh = parseInt(time / 2) + ":30";
      }
      time = e.appointmentEnd;
      if (time % 2 == 0) {
        bh += "-" + parseInt(time / 2) + ":00";
      } else {
        bh += "-" + parseInt(time / 2) + ":30";
      }
      e["BH"] = bh;
      var count = parseInt((e.appointmentEnd - e.appointmentStart) / 2);
      e["TimeCount"] =
        (e.appointmentEnd - e.appointmentStart) % 2 == 0 ? count : count + 1;
      return bh;
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
.top {
  margin-top: 70px;
}
.move {
  display: none;
}
.computer > img {
  width: 100%;
}
.shop {
  padding: 70px 0;
}
.shop > h2 {
  font-weight: 700;
  font-size: 27px;
  margin-left: 18px;
}
.deta {
  color: #323e48;
  width: 50%;
  float: left;
}
.deta > img {
  width: 50%;
  margin-bottom: 10px;
  border-radius: 5px;
}
.deta > h3 {
  font-size: 23px;
}
.deta > p {
  font-size: 19px;
  margin: 0 0 10px 0;
  display: flex;
}
.deta > p > img {
  width: 25px;
  height: 25px;
}
.deta > button {
  width: 50%;
  /* height: 30px; */
  padding: 8px 0 8px 0;
  border: 0 none;
  color: #323e48;
  font-weight: 700;
  font-size: 16px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  border-radius: 20px;
  margin-bottom: 20px;
}
.name {
  font-size: 25px;
  font-weight: 700;
}
.cost {
  text-align: center;
  background: #ececec;
  border-radius: 0px 0px 80px 0px;
  padding-top: 20px;
  padding-bottom: 50px;
}
.cost > h3 {
  font-size: 23px;
}
.cost > p {
  font-size: 15px;
  line-height: 22px;
}
.cost > img {
  width: 85%;
}
.ensure {
  text-align: center;
  padding-top: 20px;
  padding-bottom: 50px;
}
.ensure > h3 {
  font-size: 23px;
}
.ensure > p {
  font-size: 15px;
  line-height: 22px;
  margin: 25px 0;
}
.ensure-mail {
  display: flex;
  align-items: center;
}
.ensure-mail > img {
  width: 30%;
  margin-left: auto;
  margin-right: 15px;
}
.ensure-p > p {
  color: #323e48;
  margin: 5px 0;
}
.ensure-data > img {
  width: 23%;
}
.el-button {
  margin-right: auto;
  margin-left: 15px;
}
.ensure-button {
  font-size: 16px;
  border: none;
  cursor: pointer;
  width: 40%;
  height: 35px;
  border-radius: 0 4px 4px 0;
  background: #00e467;
  margin-top: 15px;
}
.shine {
  padding: 80px 0;
  background-color: #f2f2f2;
}
.Blooming {
  text-align: center;
}
.Blooming > h2 {
  font-size: 38px;
  margin-top: 50px;
}
.Blooming > img {
  width: 20%;
}
.Blooming > a > h4 {
  cursor: pointer;
  font-size: 21px;
}
.form {
  text-align: center;
}
.form > img {
  width: 100%;
}
.advantage {
  text-align: center;
  padding: 80px 0;
}
.advantage > h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
}

.team > h4 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}
.team > p {
  padding: 0 10%;
}

.Yours {
  padding: 50px 0 200px 0;
  text-align: center;
  background-image: url(../img/Group7058.png);
  border-radius: 0 0 250px 0;
}
.live > h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
}
.lasting > img {
  width: 50%;
}
.lasting > h4 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}
.lasting > p {
  padding: 0 5%;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 992px) {
  .deta {
    margin-left: 5%;
    width: 100%;
    float: left;
  }
  .deta > button {
    width: 30%;
  }
  .deta > img {
    width: 30%;
  }
  .Yours {
    background-image: none;
    border-radius: 0;
  }
  .live {
    padding-top: 50px;
    background-color: #f2f2f2;
  }
  .lasting > img {
    width: 30%;
  }
  .live {
    text-align: center;
  }
}
@media all and (max-width: 570px) {
  .deta > img {
    width: 90%;
  }
  .deta > button {
    width: 60%;
  }
  .team > img {
    width: 25%;
    margin: 10px 0;
  }
  .lasting > img {
    width: 25%;
    margin: 10px 0;
  }
  .live {
    padding-top: 50px;
    background-color: #f2f2f2;
    text-align: center;
  }
  .Yours {
    background-image: none;
    border-radius: 0;
  }
  .shop > h2 {
    font-size: 18px;
  }
  .name {
    font-size: 18px;
  }
  .deta > h3 {
    font-size: 16px;
  }
  .deta > p {
    font-size: 15px;
  }
  .advantage > h2 {
    font-size: 27px;
  }
  .team > h4 {
    font-size: 19px;
  }
  .team > p {
    font-size: 15px;
  }
  .live > h2 {
    font-size: 27px;
  }
  .lasting > h4 {
    font-size: 19px;
  }
  .lasting > p {
    font-size: 15px;
    padding: 0 5%;
  }
  .top {
    margin-top: 42px;
  }
  .move {
    display: block;
  }
  .computer {
    display: none;
  }
  .move > img {
    width: 97%;
  }
  .Blooming > h2 {
    font-size: 27px;
    margin-top: 0px;
  }
  .Blooming > a > h4 {
    font-size: 19px;
    margin-bottom: 15px;
  }
}
</style>